import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification, Checkbox, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { DeleteOutlined, MinusCircleTwoTone, PlusCircleTwoTone, EditOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import CleaningTraceabilityApi from "../common/Apis/CleaningTraceabilityApi";
import MonthlyCleaning from "../common/Models/CleaningTraceability/MonthlyCleaning";
import AddNodeModel from "../common/Models/AddNodeModel/AddNodeModel";
import ViewNodeModel from "../common/Models/AddNodeModel/ViewNodeModel";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const MonthlyCleaningTraceability = () => {
    const [weekDates, setWeekDates] = useState([]);
    const navigate = useNavigate();
    const { Content } = Layout;
    const urlParams = new URLSearchParams(window.location.search);
    const cleanId = urlParams.get("id");
    const { Panel } = Collapse;
    const [Traceability, setTraceability] = useState([]);
    const [allTraceability, setAllTraceability] = useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [PaginatePage, setPaginatePage] = useState(0);
    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({ paginate: PaginateLimit });

    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setPageSize(value);
        setCurrentPage(1);
        setPaginatePage(0);
        formPaginate.setFieldsValue({ paginate: value });

        getCleaningTraceability(0, value, true);
    };

    // Function to fetch cleaning traceability with pagination and frequency filter
    const getCleaningTraceability = useCallback(async (page = 0, size = 10, showLoader = true) => {
        if (showLoader) {
            setIsFetching(true);
        }
        try {
            const response = await CleaningTraceabilityApi.ListCleaningTraceability(page, size, 'MONTHLY');
            
            if (response?.payloadDto) {
                // Filter by cleanId if provided
                let filteredData = response.payloadDto;
                if (cleanId) {
                    filteredData = response.payloadDto.filter(item => item?.institutionDTO?.id === parseInt(cleanId));
                }
                setTraceability(filteredData);
                setAllTraceability(response.payloadDto);
                setTotalElements(response.totalElements || 0);
                setTotalPages(response.totalPages || 0);
            }
        } catch (err) {
            console.log(err);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: err?.message || "Failed to fetch cleaning traceability",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        } finally {
            if (showLoader) {
                setTimeout(() => {
                    setIsFetching(false);
                }, 500);
            }
        }
    }, [cleanId]);

    const [isLoading, setIsLoading] = useState(false);
    
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    const getCurrentWeekDates = () => {
        const today = moment();
        const currentDay = today.day();
        const startDate = moment(today).subtract(currentDay, 'days');
        const weekDates = [];
        for (let i = 0; i < 7; i++) {
            const date = moment(startDate).add(i, 'days');
            weekDates.push(date);
        }
        setWeekDates(weekDates);
    };

    useEffect(() => {
        getCleaningTraceability(0, pageSize, true);
        PageLoading();
        getCurrentWeekDates();
    }, [getCleaningTraceability, PageLoading, pageSize]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        getCleaningTraceability(page - 1, pageSize, true);
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
        getCleaningTraceability(0, size, true);
    };

    const handleRemovefilterProduction = (FiltergetProductionIndex) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction.splice(FiltergetProductionIndex, 1);
        setFilterRecipe(newfilterProduction);
        if (FiltergetProductionIndex === 0) {
            getCleaningTraceability(0, pageSize, true);
        }
    };

    const handleClear = () => {
        getCleaningTraceability(0, pageSize, true);
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterRecipe([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const formRef = useRef(null);

    const [filterRecipe, setFilterRecipe] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterRecipe = () => {
        setFilterRecipe([
            ...filterRecipe,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        
        let singleLineString = filterRecipe
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=BETWEEN${createDateTimestamp(
                        obj.answerType
                    )}AND${createDateTimestamp(obj.name)}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
        "componentCode=CLEANING_TRACEABILITY_ASSIGN&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
        );
        
        QuestionnairesApi.FilterQuestionsetNext(filderData,0,PaginateLimit)
            .then((response) => {
                const filteredData = response.payloadDto.filter(item => item?.frequency === 'MONTHLY');
                // Apply cleanId filter if needed
                let finalData = filteredData;
                if (cleanId) {
                    finalData = filteredData.filter(item => item?.institutionDTO?.id === parseInt(cleanId));
                }
                setTraceability(finalData);
                setTotalElements(response.totalElements || 0);
                setTotalPages(response.totalPages || 0);
                setCurrentPage(1);
                setPaginatePage(0);
            })
            .catch((err) => { 
                console.log(err);
            });
    };

    const createDateTimestamp = (Cdate) => {
        const date = new Date(Cdate);
        const unixTime = Math.floor(date.getTime());
        return unixTime;
    };

    const handleChangeTitle = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].title = value;
        setFilterRecipe(newfilterProduction);
    };

    const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].answerType = value;
        setFilterRecipe(newfilterProduction);
    };

    const handleChangename = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].name = value;
        setFilterRecipe(newfilterProduction);
    };

    const [modaldailyVisible, setModaldailyVisible] = useState(false);

    const handleOpendailyModal = () => {
        setModaldailyVisible(true);
    };
    
    const handldailyCloseModal = async (shouldRefresh = false) => {
        setModaldailyVisible(false);
        if (shouldRefresh) {
            await getCleaningTraceability(currentPage - 1, pageSize, true);
        }
    };

    // Edit handlers
    const handleEditClick = (task) => {
        setSelectedTask(task);
        setEditModalVisible(true);
    };

    const handleEditCloseModal = async (shouldRefresh = false) => {
        setEditModalVisible(false);
        setSelectedTask(null);
        if (shouldRefresh) {
            await getCleaningTraceability(currentPage - 1, pageSize, true);
        }
    };

    const handleDeletTraceability = async (TraceabilityID) => {
        setIsFetching(true);
        CleaningTraceabilityApi.DeleteCleaningTraceability(TraceabilityID, 'MONTHLY')
            .then(async (response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
                    description: "Delete Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                await getCleaningTraceability(currentPage - 1, pageSize, true);
            })
            .catch((err) => {
                setIsFetching(false);
                if (err.apiError?.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };

    const [modalNodeModeVisible, setNodeMode] = useState(false);
    const [NodeModeDatas, setNodeModeDatas] = useState(false);
    
    const addNodeModeVisible = () => {
        setNodeMode(true);
        setNodeModeDatas("MONTHLY");
    };
    
    const handlNodeModeCloseModal = () => {
        setNodeMode(false);
    };

    const [modalNodeModeVisible2, setNodeMode2] = useState(false);
    const [NodeModeDatas2, setNodeModeDatas2] = useState(false);
    
    const addNodeModeVisible2 = () => {
        setNodeMode2(true);
        setNodeModeDatas2("MONTHLY");
    };
    
    const handlNodeModeCloseModal2 = () => {
        setNodeMode2(false);
    };

    const renderTableRows = () => {
        if (isFetching) {
            return (
                <tr className="text-center">
                    <td colSpan={4} className="text-center" style={{ padding: "50px" }}>
                        <div className="spinner" style={{ margin: "0 auto" }}></div>
                        <br />
                        Loading...
                    </td>
                </tr>
            );
        }
        
        if (Traceability.length > 0) {
            return Traceability.map((item) => (
                <tr key={item?.id} className="text-center">
                    <td className="pt-3" style={{ width: "25%" }}>
                        {item?.taskName || item?.traceabilityName}
                    </td>
                    <td className="pt-3" style={{ width: "20%" }}>
                        {item?.institutionDTO?.institutionName}
                    </td>
                    <td className="pt-3" style={{ width: "40%" }}>
                        {item?.description || "-"}
                    </td>
                    <td style={{ width: "15%" }}>
                        <div className="d-flex justify-content-center gap-2">
                            <Link
                                to="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleEditClick(item);
                                }}
                                className="btn btn-primary btn-save table-action icon-center"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '4px 12px',
                                    height: 'auto',
                                    textDecoration: 'none'
                                }}
                            >
                                <EditOutlined />
                                Edit
                            </Link>
                            <Popconfirm
                                title="Are you sure ?"
                                description="Do you really want to delete this Monthly Traceability ?"
                                okText="Yes"
                                onConfirm={() => handleDeletTraceability(item.id)}
                                placement="topRight"
                                className="w-100"
                                cancelText="No"
                            >
                                <Link
                                    to={``}
                                    className={decodedToken?.permissions?.some(
                                        (permission) => permission?.authority === 'DELETE_CLEANING_TRACEABILITY_MONTHLY'
                                    ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                                >
                                    <DeleteOutlined />
                                    Delete
                                </Link>
                            </Popconfirm>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (
                <tr className="text-center EmptyTable">
                    <td colSpan={4} className="text-center">
                        <img
                            src="/assest/Images/emptyIcon.svg"
                            className="logo-png mt-3"
                            style={{ width: "10%" }}
                            alt="No data"
                        />
                        <br />
                        No Data Available
                    </td>
                </tr>
            );
        }
    };
    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }


    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {(isLoading || isFetching) && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterRecipe.map((input, filterProductionIndex) => (
                                        <div key={filterProductionIndex}>
                                            <Row gutter={24} className="pt-2">
                                                <Col lg={5} md={5} className="px-1">
                                                    <Form.Item
                                                        name={`title${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterProductionIndex, value)
                                                            }
                                                            options={[
                                                                {
                                                                    value: "taskName",
                                                                    label: "Task Name",
                                                                },
                                                                {
                                                                    value: "description",
                                                                    label: "Description",
                                                                },
                                                                {
                                                                    value: "institutionDTO.institutionName",
                                                                    label: "Department",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col lg={4} md={4} className="px-1">
                                                    <Form.Item
                                                        name={`type${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select type.",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select mb-1"
                                                            placeholder="Condition"
                                                            onChange={(value) =>
                                                                handleChangeAnswertype(
                                                                    filterProductionIndex,
                                                                    value
                                                                )
                                                            }
                                                            options={[
                                                                { value: "%", label: "Matches with" },
                                                                {
                                                                    value: "=",
                                                                    label: "Equals to",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col lg={5} md={5} className="px-1">
                                                    <Form.Item
                                                        name={`name${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please enter Text.",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            type="text"
                                                            onChange={(e) =>
                                                                handleChangename(
                                                                    filterProductionIndex,
                                                                    e.target.value
                                                                )
                                                            }
                                                            placeholder="Text"
                                                            className="control-input"
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col lg={8} md={10} className="px-1">
                                                    <Form.Item className="text-lable">
                                                        {filterProductionIndex === 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterRecipe}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center"
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterProduction(
                                                                            filterProductionIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Space>
                            <Button
                                type="primary"
                                onClick={handleOpendailyModal}
                                disabled={isFetching}
                                style={{
                                    display: decodedToken?.permissions?.some(
                                        permission => permission?.authority === 'ADD_CLEANING_TRACEABILITY_MONTHLY'
                                    ) ? '' : 'none',
                                    height: 'auto',
                                    lineHeight: 'normal',
                                    alignItems: 'center',
                                    padding: '5px 24px',
                                }}
                            >
                                Add Monthly Task
                            </Button>
                            {/* <Button
                                type="primary"
                                onClick={addNodeModeVisible}
                                disabled={isFetching}
                                style={{
                                    display: decodedToken?.permissions?.some(
                                        permission => permission?.authority === 'ADD_CLEANING_TRACEABILITY_MONTHLY'
                                    ) ? '' : 'none',
                                    height: 'auto',
                                    lineHeight: 'normal',
                                    alignItems: 'center',
                                    padding: '5px 24px',
                                }}
                            >
                                Add Manager Note
                            </Button> */}
                            {/* <Button
                                type="primary"
                                onClick={addNodeModeVisible2}
                                disabled={isFetching}
                                style={{
                                    display: decodedToken?.permissions?.some(
                                        permission => permission?.authority === 'ADD_CLEANING_TRACEABILITY_MONTHLY'
                                    ) ? '' : 'none',
                                    height: 'auto',
                                    lineHeight: 'normal',
                                    alignItems: 'center',
                                    padding: '5px 24px',
                                }}
                            >
                                View Manager Note
                            </Button> */}
                        </Space>

                        <Form form={formPaginate}>
                        <Form.Item name="paginate" className="text-lable" style={{ width: '100px', marginBottom: 0 }}>
                            <Select
                                className="control-Select"
                                onChange={(value) => handlesetPaginateLimit(value)}
                                options={[
                                    { value: 10,  label: "10"  },
                                    { value: 20,  label: "20"  },
                                    { value: 30,  label: "30"  },
                                    { value: 40,  label: "40"  },
                                    { value: 50,  label: "50"  },
                                    { value: 100, label: "100" },
                                ]}
                            />
                        </Form.Item>
                    </Form>
                    </div>
                    <div>

                        <table className="table users-table" style={{ marginTop: '20px' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "25%" }}>Task Name</th>
                                    <th style={{ width: "20%" }}>Department</th>
                                    <th style={{ width: "40%" }}>Description</th>
                                    <th style={{ width: "15%" }} className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                        {Traceability.length > 0 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            maxVisiblePages={5}
                            showPageInfo={true}
                            totalItems={totalElements}
                            pageSize={pageSize}
                        />
                        )}

                    </div>
                </Content>

                {/* Add Monthly Cleaning Modal */}
                <MonthlyCleaning
                    visible={modaldailyVisible}
                    onClose={handldailyCloseModal}
                    isEditMode={false}
                />

                {/* Edit Monthly Cleaning Modal */}
                {editModalVisible && selectedTask &&
                    <MonthlyCleaning
                        visible={editModalVisible}
                        onClose={handleEditCloseModal}
                        editData={selectedTask}
                        isEditMode={true}
                    />
                }

                {modalNodeModeVisible &&
                    <AddNodeModel
                        visible={modalNodeModeVisible}
                        onClose={handlNodeModeCloseModal}
                        NodeModeDatas={NodeModeDatas}
                    />
                }

                {modalNodeModeVisible2 &&
                    <ViewNodeModel
                        visible={modalNodeModeVisible2}
                        onClose={handlNodeModeCloseModal2}
                        NodeModeDatas={NodeModeDatas2}
                    />
                }
                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default MonthlyCleaningTraceability;